import { addDays, format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

const FORMATS = {
  summary: "dd/MM/yyyy",
  pdp: "d 'de' MMM",
};

export function getDeliveryDate({
  estimatedDeliveryDate,
  estimatedBusinessDays,
} = {}) {
  if (estimatedDeliveryDate) {
    return parseISO(estimatedDeliveryDate);
  }
  const days = parseInt(estimatedBusinessDays, 10);
  if (!days || Number.isNaN(days)) return null;
  return addDays(new Date(), days);
}

export function formatDeliveryEstimate({
  estimatedDeliveryDate,
  estimatedBusinessDays,
  variant = "pdp",
} = {}) {
  const date = getDeliveryDate({ estimatedDeliveryDate, estimatedBusinessDays });
  if (!date) return "—";
  if (variant === "summary") {
    return format(date, FORMATS.summary);
  }
  return format(date, FORMATS.pdp, { locale: ptBR });
}
